import { create } from 'zustand';

export type TourId = 'authoring' | 'reviews' | 'reviewing';

interface TourStore {
  activeTour: TourId | null;
  showTour: boolean;
  startTour: (tourId: TourId) => void;
  stopTour: () => void;
  setActiveTour: (tourId: TourId | null) => void;
}

export const useTourStore = create<TourStore>((set) => ({
  activeTour: null,
  showTour: false,
  startTour: (tourId) => set({ showTour: true, activeTour: tourId }),
  stopTour: () => set({ showTour: false, activeTour: null }),
  setActiveTour: (tourId) => set({ activeTour: tourId }),
}));
